// Global functions which are called from save user card iframes and mobile app(?) to retrieve credit card information
var creditCardInfo = {};
var __getCreditCardInfo = function() {
    return JSON.stringify(creditCardInfo);
};

var __setCreditCardInfo = function(data) {
    creditCardInfo = data;
}

window.__getCreditCardInfo = __getCreditCardInfo;
window.__setCreditCardInfo = __setCreditCardInfo;

// Module imports loaded by their dependencies - do not change the ordering...
import './payment/jquery.cardswipe';
import './payment/jquery.i4goTrueToken.1.0.0';
import './payment/magstripe';
import './payment/cardConnect';
import './payment/I4go';
import './payment/IDTech';
import './payment/TakePayment';
import './payment/EmvTerminal';
import './payment/PaymentController';

import {
    cardConnectFrameDialogServiceBillingInfo, cardConnectFrameDialogServiceRefund 
} from './payment/CardConnect/cardConnectFrameDialogForm';
import cardConnectIframeDialogMembershipBillingInformation from './payment/CardConnect/cardConnectIframeDialogMembershipBillingInformation';
import cardConnectIframeSaveUserCard from './payment/CardConnect/cardConnectFrameSaveUserCard';
import CardConnectTakePayment from './payment/CardConnect/CardConnectTakePayment';
import {
    i4goFrameDialogServiceBillingInfo, i4goFrameDialogServiceRefund 
} from './payment/i4go-frame/I4goFrameDialogForm';
import I4goIframeDialogCardIsExpired from './payment/i4go-frame/I4goIframeDialogCardIsExpired';
import I4goIframeDialogMembershipBillingInformation from './payment/i4go-frame/I4goIframeDialogMembershipBillingInformation';
import I4goIframeSaveUserCard from './payment/i4go-frame/I4goFrameSaveUserCard';
import i4goIframeTakePayment from './payment/i4go-frame/I4goFrameTakePayment';

// globals
window.cardConnectFrameDialogServiceBillingInfo = cardConnectFrameDialogServiceBillingInfo;
window.cardConnectFrameDialogServiceRefund = cardConnectFrameDialogServiceRefund;
window.cardConnectIframeDialogMembershipBillingInformation = cardConnectIframeDialogMembershipBillingInformation;
window.cardConnectIframeSaveUserCard = cardConnectIframeSaveUserCard;
window.CardConnectTakePayment = CardConnectTakePayment;
window.i4goFrameDialogServiceBillingInfo = i4goFrameDialogServiceBillingInfo;
window.i4goFrameDialogServiceRefund = i4goFrameDialogServiceRefund;
window.I4goIframeDialogCardIsExpired = I4goIframeDialogCardIsExpired;
window.I4goIframeDialogMembershipBillingInformation = I4goIframeDialogMembershipBillingInformation;
window.i4goIframeSaveUserCard = I4goIframeSaveUserCard;
window.i4goIframeTakePayment = i4goIframeTakePayment;

import '../styles/payment/take-payment.css';
